// Source-controlled readiness, not a browser or environment permission switch.
// There is deliberately no configurable upstream or compatibility fallback.
export const TMS_CONNECTION_READY = false;
export const TMS_CONNECTION_MESSAGE =
  'This service is unavailable while the website is being connected to TMS. No payment or request has been submitted.';

export function unavailableTmsOperation() {
  const error = new Error(TMS_CONNECTION_MESSAGE);
  error.code = 'TMS_CONNECTION_PENDING';
  error.retryable = false;
  throw error;
}
